import { render } from "./TwelveHeader.vue?vue&type=template&id=66b7696e"
import script from "./TwelveHeader.vue?vue&type=script&lang=js"
export * from "./TwelveHeader.vue?vue&type=script&lang=js"

import "./TwelveHeader.vue?vue&type=style&index=0&id=66b7696e&lang=css"
script.render = render

export default script